import React from 'react';

import { useTranslation } from 'providers/GILT.provider';

const TextNewClient = () => {
  const { t } = useTranslation();

  return (
    <div data-bem="TextNewClient">
      <div className="bottom-text">
        <span>{t('clientConnect.sectionsDescriptionPart1')}</span> {t('clientConnect.section5DescriptionPart2')}
      </div>
    </div>
  );
};

export default TextNewClient;
